module.exports = __webpack_public_path__ + "static/media/wiper_baldes.b5d54ad3.svg";